
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

//require('./constants.js');
require('./bootstrap');
// require('es6-promise/auto');

// window.Vue = require('vue');
window.Vue = require('vue').default;

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

//Vue.component('example-component', require('./components/ExampleComponent.vue'));


import apiService from './services/api-service.js';

import TicketDetails from './app/ticket-details.vue';
import TicketCreate from './app/ticket-create.vue';
import UserDetails from './app/user-details.vue';
import UserList from './app/user-list.vue';
import EdificioDetails from './app/edificio-details.vue';

const app = new Vue({
  el: '#app',
  components: {
    'app': {
      props: [
        'ajaxUrl',
        'apiUrl'
      ],
      created() {
        apiService.ajaxUrl = this.ajaxUrl;
        apiService.apiUrl = this.apiUrl;
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
          $('.datepicker').datepicker({
            language: 'es-ES',
            format: 'yyyy-mm-dd',
            autoclose: true
          });
        });
      },
      components: {
        'ticket-details': TicketDetails,
        'ticket-create': TicketCreate,
        'user-list': UserList,
        'user-details': UserDetails,
        'edificio-details': EdificioDetails,
      }
    }
  }
});